import DynamicForm from "../../../../components/FormElements/DynamicForm";
import * as Yup from 'yup';
import { FaEnvelope } from "react-icons/fa";
import { Col, Row } from "antd";
import logo from '../../../../assets/images/logo.png'
import AuthLayout from "../../../../components/Layout/AuthLayout";
import './style.css'
import Button from "../../../../components/FormElements/Button";
import { Link, useNavigate } from "react-router-dom";
import { authTypes } from "../../../../config/utils/constants";
import useAuthApi from "../../../../config/hooks/api/auth/useAuthApi";
import { setAppLoading, setError, setMessage } from "../../../../store/common/generalSlice";
import { useDispatch } from "react-redux";

const ForgotPassword = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { forgotPassword } = useAuthApi()

  // Define the form configuration
  const form = {
    name:'forgotPasswordForm',
    formFields: [
      {
        name: 'email',
        type: 'email',
        label: { value:'Email Address', style:'', classes:'' },
        placeholder: 'Email',
        width: { md: 24, sm: 24, xs: 24 },
        component: null,
        classes: 'icon-primary',
        icon: <FaEnvelope />
      },
    ],
    formValidation: {
      email: Yup.string().email('Email is invalid').required('Email is required'),
    },
  }

  const handleSubmit = async (values) => {
    try {
      if(!values || !Object.keys(values).length){
        dispatch(setError("Fields should not be empty"))
        return
      } 

      const { email } = values

      dispatch(setAppLoading(true))

      const response = await forgotPassword({ email })
      if (response) {
        if(!response?.data){
          dispatch(setError('Something went wrong'))
          dispatch(setAppLoading(false))
          return 
        } 

        dispatch(setMessage(response?.data?.message))
        dispatch(setAppLoading(false))

        const tempData = response?.data?.user
        tempData.type = authTypes.indexOf('forgotPassword')
        localStorage.setItem('tempUser', JSON.stringify(tempData))

        navigate('/verify-otp')
      }
    } catch (error) {
      console.error("Error:", error);
      dispatch(setAppLoading(false))
    }
  };

  const submitForm = () => {
    document.querySelector('form')?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
  }

  return (
    <AuthLayout>
      <Row className="flex justify-center forgot-password-screen custom-card-boxshadow px-4 py-5 rounded-md">
        <Col xs={24} sm={14} md={14} className="form-section">
          <img src={logo} alt='logo' className="img-fluid logo mb-8"/>
          <h4 className="heading-4 font-bold mb-4">Forgot Password</h4>
          <p className="text-slate-500 mb-8 text-center">Enter your Email address for verification process, we will send a 4 digit code to your email.</p>
          <DynamicForm onSubmit={handleSubmit} form={form} />
          <div className="flex justify-start w-full mb-6">
            <Button.Basic 
              onClick={submitForm}
              disabled={false}
              icon={null}
              loading={false}
              type="primary" 
              size='medium'
              text='Submit'
              className='btn-primary md:w-fit sm:w-fit w-full'
            />
          </div>
          <div className="text-slate-300 dashed-line w-full mb-3"></div>
          <div className="mb-3 flex justify-start w-full">
            <div className="md:text-left sm:text-left text-center">
              <small className="text-slate-400">Back to</small>
              <Link to='/login' className="ml-1 font-bold">Login</Link>
            </div>
          </div>
          <div className="text-slate-300 dashed-line w-full mb-6"></div>
          {/* <div className="flex justify-center">
            <div>
              <p className="text-xs text-slate-400 mb-2">Or Continue With</p>
              <div className="flex justify-between">
                { socialLogin.map(item => (
                  <span key={item.name}>
                  { item.icon }
                  </span>
                )) }
              </div>
            </div>
          </div> */}
        </Col>
      </Row>
    </AuthLayout>
  );
};

export default ForgotPassword;
